import { LegalLayout } from "./LegalLayout";

const CONTACT_EMAIL = "bmabma79@gmail.com";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="22 June 2026">
      <p>
        These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the African
        Polistas Operations Dashboard and its associated WhatsApp and
        Telegram bots (the &ldquo;Service&rdquo;), provided by{" "}
        <strong>African Polistas</strong> (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;).
      </p>

      <p>
        The Service is a private internal tool. Access is granted only to
        authorised staff, contractors, and executives of African Polistas.
        By accessing the Service, you agree to these Terms.
      </p>

      <h2>1. Eligibility and access</h2>
      <ul>
        <li>
          You must be at least 16 years old and authorised by African
          Polistas management to use the Service.
        </li>
        <li>
          You are responsible for keeping your account credentials
          confidential. Notify us immediately at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> if you
          suspect unauthorised access.
        </li>
      </ul>

      <h2>2. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>
          Use the Service for any purpose unrelated to African Polistas
          operations.
        </li>
        <li>
          Share, leak, or publish operational data with anyone outside the
          organisation without express permission.
        </li>
        <li>
          Attempt to access data, accounts, or systems you are not
          authorised to access.
        </li>
        <li>
          Reverse engineer, scrape, or attempt to disrupt the Service or its
          underlying infrastructure.
        </li>
        <li>
          Submit content that is unlawful, defamatory, or infringes any third
          party&apos;s rights.
        </li>
      </ul>

      <h2>3. Data you submit</h2>
      <p>
        Any operational data you submit (messages, invoices, photos,
        annotations) remains the property of African Polistas. You confirm
        that you have the right to submit such content and that doing so
        does not violate any law or third-party right.
      </p>

      <h2>4. Bots</h2>
      <ul>
        <li>
          The WhatsApp bot operates on the WhatsApp Cloud API under Meta&apos;s
          Platform Policies. By messaging the bot you also accept{" "}
          <a href="https://www.whatsapp.com/legal/business-terms">
            WhatsApp&apos;s Business Messaging Terms
          </a>
          .
        </li>
        <li>
          Messages to and from the bot are recorded in our system for
          operational and audit purposes. See our{" "}
          <a href="/privacy">Privacy Policy</a>.
        </li>
        <li>
          Group chats are not supported and any message received from a
          group is dropped without processing.
        </li>
      </ul>

      <h2>5. Availability</h2>
      <p>
        We aim to keep the Service available at all times but provide it on
        an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis without warranties of any kind.
        Scheduled maintenance, third-party outages, or unforeseen incidents
        may cause downtime.
      </p>

      <h2>6. Suspension and termination</h2>
      <p>
        We may suspend or terminate your access at any time, with or without
        notice, if we believe you have violated these Terms or if access is
        no longer appropriate for your role.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, African Polistas, its
        directors, and its service providers are not liable for any
        indirect, incidental, or consequential damages arising from your use
        of the Service.
      </p>

      <h2>8. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the
        Service after a change constitutes acceptance of the updated Terms.
      </p>

      <h2>9. Governing law</h2>
      <p>
        These Terms are governed by the laws of the Republic of South
        Africa, without regard to its conflict-of-law provisions.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these Terms? Write to:{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}
